import { render, staticRenderFns } from "./HealthStationPerson.vue?vue&type=template&id=68c0826e&scoped=true"
import script from "./HealthStationPerson.vue?vue&type=script&lang=js"
export * from "./HealthStationPerson.vue?vue&type=script&lang=js"
import style0 from "./HealthStationPerson.vue?vue&type=style&index=0&id=68c0826e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c0826e",
  null
  
)

export default component.exports